/**
 * Small KPI tile used across the Banking Hub (Incoming, Outgoing, etc.).
 * Kept intentionally dumb so variants can be added by just passing a new
 * `tone` key without touching callers.
 */
export default function TileCard({ icon, label, value, sub, tone, testid }) {
  const toneMap = {
    emerald: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    rose: 'bg-rose-50 text-rose-700 border-rose-200',
    sky: 'bg-sky-50 text-sky-700 border-sky-200',
    violet: 'bg-violet-50 text-violet-700 border-violet-200',
  };
  return (
    <div className={`rounded-xl border p-3 ${toneMap[tone] || ''}`} data-testid={testid}>
      <div className="flex items-center gap-1.5 text-[11px] font-semibold opacity-80">
        {icon}
        <span>{label}</span>
      </div>
      <p className="font-bold text-xl mt-1 tabular-nums">{value}</p>
      {sub ? <p className="text-[10px] opacity-70 -mt-0.5">{sub}</p> : null}
    </div>
  );
}
